// client/src/routes/app/properties/$propertyId/insurance.tsx — SCR-PROP-003 tab „Asigurări" ·
// MAINT-006 (04 §8.3's tab set, „**Asigurări** (M3 — SCR-INS-001 panel embed)").
//
// The tab that §8.3 marks M3, arriving with the item whose brief names „the insurance panel
// slot on SCR-PROP-003". What it renders and what it deliberately leaves to MAINT-009 is
// written at the top of `features/properties/InsurancePanel.tsx`.
//
// `Operations.Read` on top of the layout's `Portfolio.Read`: policies are the Operations
// module's rows (`InsurancesEndpoints` gates every one of them on it), so a membership that may
// see the property but not its operations gets SCR-SYS-403 here rather than a panel full of
// 403s — the split the costs tab makes for `Expenses.Read` (D-725).
//
// No search params: this tab has no filters. When MAINT-009 gives the panel a „doar polițele în
// vigoare" control it becomes a §9.2.3 schema like the costs tab's, and this file grows a
// `validateSearch`.

import { createFileRoute } from '@tanstack/react-router';

import { RequirePermission } from '@/components/layout/route-guards';
import { InsurancePanel } from '@/features/properties/InsurancePanel';

export const Route = createFileRoute('/app/properties/$propertyId/insurance')({
  component: InsuranceTabScreen,
});

function InsuranceTabScreen() {
  const { propertyId } = Route.useParams();

  return (
    <RequirePermission permission="Operations.Read">
      <InsurancePanel propertyId={propertyId} />
    </RequirePermission>
  );
}
